export var CANADA_PROVINCE_SHORTHAND_TO_NAME = function(strictLocalize) {
    return {
        AB: strictLocalize({
            id: "nb+kkC",
            defaultMessage: [
                {
                    type: 0,
                    value: "Alberta"
                }
            ]
        }),
        BC: strictLocalize({
            id: "Bo4meK",
            defaultMessage: [
                {
                    type: 0,
                    value: "British Columbia"
                }
            ]
        }),
        MB: strictLocalize({
            id: "d0cjWG",
            defaultMessage: [
                {
                    type: 0,
                    value: "Manitoba"
                }
            ]
        }),
        NB: strictLocalize({
            id: "3fmcbf",
            defaultMessage: [
                {
                    type: 0,
                    value: "New Brunswick"
                }
            ]
        }),
        NL: strictLocalize({
            id: "0OzQs+",
            defaultMessage: [
                {
                    type: 0,
                    value: "Newfoundland"
                }
            ]
        }),
        NS: strictLocalize({
            id: "VOAvWB",
            defaultMessage: [
                {
                    type: 0,
                    value: "Nova Scotia"
                }
            ]
        }),
        NT: strictLocalize({
            id: "ZdHac+",
            defaultMessage: [
                {
                    type: 0,
                    value: "Northwest Territories"
                }
            ]
        }),
        NU: strictLocalize({
            id: "LtXM4X",
            defaultMessage: [
                {
                    type: 0,
                    value: "Nunavut"
                }
            ]
        }),
        ON: strictLocalize({
            id: "9z2hx9",
            defaultMessage: [
                {
                    type: 0,
                    value: "Ontario"
                }
            ]
        }),
        PE: strictLocalize({
            id: "aAyvI/",
            defaultMessage: [
                {
                    type: 0,
                    value: "Prince Edward Island"
                }
            ]
        }),
        QC: strictLocalize({
            id: "l3ioHC",
            defaultMessage: [
                {
                    type: 0,
                    value: "Quebec"
                }
            ]
        }),
        SK: strictLocalize({
            id: "PA3ZGu",
            defaultMessage: [
                {
                    type: 0,
                    value: "Saskatchewan"
                }
            ]
        }),
        YT: strictLocalize({
            id: "aokx8C",
            defaultMessage: [
                {
                    type: 0,
                    value: "Yukon"
                }
            ]
        })
    };
};
